import { useMemo } from 'react';

// Custom components
import ChecklistIcon from 'components/ChecklistIcon';
import UserAvatar from 'components/Avatar';
import CustomButton from 'components/Button/CustomButton';

// MUI components
import { Stack, Typography, Box, Divider } from '@mui/material';

// Icons
import MobileIcon from 'components/Icons/mobileIcon';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// Hooks
import useDateTime from 'utils/CustomHooks/useDateTime';
import EditIconPencilBottomLine from 'components/Icons/editIconPencilBottomLine';
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';

interface HeaderPropTypes {
  handleClickClose: () => void;
  checklistLog?: any;
}

const Header = ({ checklistLog, handleClickClose }: HeaderPropTypes) => {
  const { getDateInTz } = useDateTime();
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();

  return (
    <Stack
      bgcolor={'#fff'}
      p={'16px 30px'}
      direction={'row'}
      justifyContent={'space-between'}
    >
      <Stack width={'70%'} gap="6px" direction={'row'} alignItems={'center'}>
        <Stack
          direction={'row'}
          alignItems={'center'}
          gap="12px"
          borderRight="1px solid #E0E0E0"
          pr="12px"
        >
          <CloseRoundedIcon onClick={handleClickClose} />
        </Stack>

        <Stack direction={'row'} alignItems={'center'} gap="12px">
          <ChecklistIcon width={30} height={30} icon={checklistLog.icon} />
          <Typography
            color="rgba(37, 35, 80, 1)"
            fontSize={'20px'}
            fontWeight={'600'}
            letterSpacing={'0.15px'}
            sx={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
            maxWidth={'95%'}
          >
            {checklistLog.name}
          </Typography>
        </Stack>
      </Stack>
      <Stack direction={'row'} gap="12px" height="36px">
        <CustomButton
          variant="contained"
          color="primary"
          sx={{
            borderRadius: '8px',
          }}
          onClick={() => {
            navigateWithWorkspaceUrl(
              `/edit-checklist/${checklistLog?.Checklist?.id}/?logId=${
                checklistLog?.id
              }&prevUrl=${`/templates/${checklistLog?.Checklist?.id}?tab=2`}`,
            );
          }}
        >
          <EditIconPencilBottomLine
            sx={{
              fontSize: '16px',
              '& path': {
                stroke: 'currentColor',
                strokeOpacity: 1,
              },
              marginRight: '5px',
            }}
          />
          Edit Submission
        </CustomButton>
      </Stack>
    </Stack>
  );
};

export default Header;
